import { render } from "./settings_email.vue?vue&type=template&id=52e61217"
import script from "./settings_email.vue?vue&type=script&lang=js"
export * from "./settings_email.vue?vue&type=script&lang=js"
script.render = render

export default script